import { Expose, Type } from 'class-transformer';
import { SupportUserDto } from './support-user.dto';

export class AddNewServiceCallResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'contact_id' })
  contactId: string;
  @Expose({ name: 'visitt_order_id' })
  visittOrderId: string;
  @Expose({ name: 'status' })
  status: string;
  @Expose({ name: 'created_at' })
  created_at: Date;
}
